import React from "react";
import "./MonitoringApproach.css";
import image from "../monitoringassets/approachimg.png";

export default function MonitoringApproach() {
  return (
    <div className="outsourcemainclass">
      <div id="monitor-approach">
        <div id="heroprogressive">
          <div className="main-container">
            <div className="left">
              <h1 className="h1-tag">
                PWAs Optimized for Speed, Reach, and Stability
              </h1>
              <p>
                Our PWA solutions are built for teams that want speed,
                stability, and engagement without technical headaches.
                Everything is optimized for performance, retention, and
                long-term scalability.
              </p>
            </div>
            <div className="right">
              <img src={image} alt="error" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
